import React, { useState } from "react";
import { User } from "@pollyslack/hub/src/types";
import { Code } from "src/components/Code";
import { ExpanderToggle } from "src/components/Expander";
import moment from "moment";
import styled from "styled-components";
import { UserLink } from "src/components/DocumentLink";
import Loader from "src/common/Loader";

const StyledTable = styled.table.attrs({
  className: "table table-dark table-sm table-hover overflow-auto",
})``;

const TableCell = styled.td`
  vertical-align: middle !important;
`;

const CaretCell = styled(TableCell)`
  width: 40px;
`;

const JsonContent = styled.div`
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
`;

const ExpandedContent = styled.td.attrs<{ colSpan: number }>((props) => ({
  colSpan: props.colSpan,
  className: "p-3",
}))`
  max-width: 0;
`;

const OtherMessageRow = ({
  message,
  user,
  showUser,
}: {
  message: any;
  user?: User;
  showUser: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <tr>
        <CaretCell>
          <ExpanderToggle expanded={isOpen} toggle={toggle} label="" />
        </CaretCell>
        <TableCell>{message._id || "—"}</TableCell>
        {showUser && (
          <>
            <TableCell>
              {user ? (
                <UserLink docId={user._id}>{message.user}</UserLink>
              ) : (
                "—"
              )}
            </TableCell>
            <TableCell>{user?.profile.email || "—"}</TableCell>
            <TableCell>{user?.profile.title || "—"}</TableCell>
          </>
        )}
        <TableCell>
          {message.createdAt
            ? moment(message.createdAt).format("MM/DD/YYYY")
            : "—"}
        </TableCell>
        <TableCell>{message.status || "—"}</TableCell>
        <TableCell>{message.channelType || "—"}</TableCell>
      </tr>
      {isOpen && (
        <tr>
          <ExpandedContent colSpan={showUser ? 8 : 5}>
            <JsonContent>
              <Code object={message} />
            </JsonContent>
          </ExpandedContent>
        </tr>
      )}
    </>
  );
};

export const OthersMessagesTable: React.FC<{
  messages: any[];
  users?: User[];
  showUser: boolean;
  isLoading?: boolean;
}> = ({ messages, users, showUser, isLoading }) => {
  const userMap = (users || []).reduce((acc, u) => {
    acc[u.profile.user_id] = u;
    return acc;
  }, {} as Record<string, User>);

  if (isLoading) return <Loader />;

  return (
    <StyledTable>
      <thead>
        <tr>
          <th />
          <th>Message ID</th>
          {showUser && <th>User ID</th>}
          {showUser && <th>User Email</th>}
          {showUser && <th>User Title</th>}
          <th>Created At</th>
          <th>Status</th>
          <th>Channel Type</th>
        </tr>
      </thead>
      <tbody>
        {(messages || [])
          .slice()
          .sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
          )
          .map((message) => {
            const messageUser = showUser ? userMap[message.user] : users?.[0];
            return (
              <OtherMessageRow
                key={message._id}
                message={message}
                user={messageUser}
                showUser={showUser}
              />
            );
          })}
      </tbody>
    </StyledTable>
  );
};
